import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { useEffect, useState } from "react";
import CustomTextarea from "../../../component/CustomTextarea";
import UploadTile from "../../../component/UploadTile";
import userProfile from "../../../assets/images/icon_plus_white.svg";
import CustomInput from "../../../component/CustomInput";

function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

const EditGroupPop = ({ btnLoader, progress, handleUpdateGroup, onProfileChange, handleChange, categoryData, handleModalClose }) => {
    categoryData['bio_raw'] = categoryData['bio_raw'].replace(/<\/?[^>]+(>|$)/g, "");
    const [form] = Form.useForm();
    const [data, setData] = useState(categoryData);
    let forceUpdate = useForceUpdate();

    useEffect(() => {
        setData(categoryData)
    }, [categoryData])

    const deleteLogoImage = () => {
        let newData = categoryData;
        newData.logo = '';
        setData(newData)
        forceUpdate()
    }

    return (
        <div className="modal_body">
            <div className="add_thought_leader">
                <Form
                    form={form}
                    name="register"
                    onFinish={(e) => handleUpdateGroup(e, form)}
                    initialValues={data}
                    scrollToFirstError
                    className="attached_courses-add_skill"
                >
                    <h2>Edit group</h2>
                    <div>
                        <Form.Item name="name" className="form_group">
                            <CustomInput label='Group Name' autoComplete={"off"} onChange={handleChange} name="name" type="text" className="form_control" />
                        </Form.Item>
                        <Form.Item name="bio_raw" className="form_group">
                            <CustomTextarea
                                progress={progress}
                                label="Bio"
                                name="bio_raw"
                                onChange={handleChange}
                                customClass="form_label_multiple_option"
                                errors={''}
                            />
                        </Form.Item>
                        <UploadTile
                            progress={progress}
                            name="cover_image"
                            handleChange={onProfileChange}
                            value={data?.cover_image || userProfile}
                            handleError={() => { }}
                            accept="image/*"
                            speTitle='Cover Image'
                            className={`${!data?.cover_image ? 'default_add_icon xyz' : ''}`}
                        />
                        <UploadTile
                            progress={progress}
                            grouplogo={true}
                            deleteLogoImage={deleteLogoImage}
                            name="logo"
                            handleChange={onProfileChange}
                            value={data?.logo || userProfile}
                            handleError={() => { }}
                            accept="image/*"
                            speTitle='Logo'
                            className={`group_logo ${!data?.logo ? 'default_add_icon' : ''}`}
                        />
                    </div>
                    <div className="form_group form_footer">
                        <FilledButton type="submit" loading={btnLoader} className="btn btn_primary" value="Update" />
                    </div>
                </Form>
            </div >
        </div >
    )
};

export default EditGroupPop;